import { Observable } from 'rxjs';
import { ApplianceFormSubmit, ParseResponse } from '.';

export interface ApplianceDetailsFormDataProvider {
  priority: number;
  getApplianceDetailsForm(): Observable<ParseResponse<ApplianceFormSubmit>>;
}
